/* eslint-disable no-shadow */

import ggStore from 'ggApp/modules/store';
import ggForm from 'ggApp/modules/form';

import React, { Component } from 'react';
import { Fields } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import * as ggAuthActions from '../../actions';
import GGUpdatePhone from './updatePhone';
import GGConfirmPhone from './confirmPhone';

import styles from './index.module.scss';

@connect(
    createStructuredSelector({
        reduxForm: ggForm.selectors.reduxForm,
        phonePrefixes: ggStore.selectors.phonePrefixes,
    }),
    (dispatch) => ({
        ggAuthActions: bindActionCreators(ggAuthActions, dispatch),
    }),
)
export default class FormsPhoneVerification extends Component {
    render() {
        const {
            updatePhone,
            confirmPhone,
            ggAuthActions,
            dark,
            namesUpdate,
            namesConfirm,
            authFetching,
            formName,
            reduxForm,
            authPhoneVerification,
            phonePrefixes,
        } = this.props;
        const phoneNumber =
            reduxForm[formName] && reduxForm[formName].values && reduxForm[formName].values.phone
                ? `${reduxForm[formName].values.phone.code}${reduxForm[formName].values.phone.number}`
                : '';

        return (
            <div className={styles.formsPhoneVerification}>
                <Fields
                    dark={dark}
                    reqMark
                    names={namesUpdate}
                    updatePhone={updatePhone}
                    authFetching={authFetching}
                    component={GGUpdatePhone}
                    phonePrefixes={phonePrefixes}
                    authReset={ggAuthActions.phoneVerificationInputHide}
                    authPhoneVerification={authPhoneVerification}
                    disabled={authPhoneVerification.progress}
                    resetAsyncValidation={ggAuthActions.phoneVerificationSetAsyncErrors}
                />
                {authPhoneVerification.progress && (
                    <Fields
                        dark={dark}
                        reqMark
                        disabled={authFetching}
                        names={namesConfirm}
                        confirmPhone={(code) => confirmPhone(code, phoneNumber)}
                        authFetching={authFetching}
                        component={GGConfirmPhone}
                        authUpdatePhone={updatePhone}
                        authReset={ggAuthActions.phoneVerificationInputHide}
                        authPhoneVerification={authPhoneVerification}
                        resetAsyncValidation={ggAuthActions.phoneVerificationSetAsyncErrors}
                    />
                )}
            </div>
        );
    }
}
